import { render, staticRenderFns } from "./StatusBoard.vue?vue&type=template&id=19371f7c&scoped=true"
import script from "./StatusBoard.vue?vue&type=script&lang=js"
export * from "./StatusBoard.vue?vue&type=script&lang=js"
import style0 from "./StatusBoard.vue?vue&type=style&index=0&id=19371f7c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19371f7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19371f7c')) {
      api.createRecord('19371f7c', component.options)
    } else {
      api.reload('19371f7c', component.options)
    }
    module.hot.accept("./StatusBoard.vue?vue&type=template&id=19371f7c&scoped=true", function () {
      api.rerender('19371f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/StatusBoard.vue"
export default component.exports